module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-13.f025625d.png";